import { Ability } from '@casl/ability';

// Creating a global instance of the ability object
export const ability = new Ability([]);